import { HasFinancingEventInclusionMethod } from "@/generated/company-search";

export const INCLUSION_LABELS: Record<
  HasFinancingEventInclusionMethod,
  string
> = {
  [HasFinancingEventInclusionMethod.ANY_PRESENT]: "With a financing event",
  [HasFinancingEventInclusionMethod.NONE_PRESENT]: "Without a financing event",
};

export const DISCOVERED_WITHIN_OPTIONS: Array<{
  value: number | null;
  label: string;
}> = [
  { value: null, label: "Any time" },
  { value: 7, label: "Last 7 days" },
  { value: 30, label: "Last 30 days" },
  { value: 90, label: "Last 90 days" },
  { value: 180, label: "Last 180 days" },
  { value: 365, label: "Last 365 days" },
];
